import { authHeader, handleResponse } from "../helpers";
export const dealerService = {
  createDealer,
  createDistributor,
  updateDistributor,
  fetchStateDLL,
  fetchCityDLL,
  fetchFirmDLL,
  updateDealer,
  updateContractor,
  fetchDealerData,
  fetchDealerDatatoApprove,
  inActiveRow,
  updatePaymentStatus,
  //fetchRoleDLL,
  fetchTransportationModeDDL,
  fetchDealerDataforExport,
  fetchDistrictDLL,
  fetchDStateDLL,
  fetchDCityDLL,
  fetchDCityDLL2,
  GETPAYMENTDDL,
  GETDOCUMENTTYPEDDL ,
  GetSalesPersonDDL,
  GetDistributorByUserId,
  fetchDistributorByUserId
};

async function fetchDistributorByUserId(userId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}UserDMaster/FrimByUserId?userId=${userId}`,
    requestOptions
  );
  console.log("Distributor API Response:", response);
  return handleResponse(response);
}
 



async function createDealer(data) {
  console.log(data);
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  };
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}UserDMaster/CreateDealer`,
    requestOptions
  );
  return handleResponse(response);
}

// async function createDistributor(data) {
//   console.log(data);
//   const requestOptions = {
//     method: "POST",
//     headers: authHeader(),
//     body: JSON.stringify(data),
//   };
//   console.log('dealer service',requestOptions)
//   const response = await fetch(
//     `${process.env.REACT_APP_API_URL}UserReg/CreateDistributor`,
//     requestOptions
//   );
//   return handleResponse(response);
// }

// In your dealer.service.js (or wherever createDistributor lives)
// ONLY change this one function — everything else stays the same.

async function createDistributor(data) {
  console.log("createDistributor raw data:", data);

  // ── Build FormData so [FromForm] on the API can bind it ──
  const formData = new FormData();

  const append = (key, val) => {
    if (val !== undefined && val !== null) {
      formData.append(key, val);
    }
  };

  // Identity
  append("UserId",              data.UserId             || "0");
  append("UserType",            data.UserType           || "2");
  append("RoleId",              data.RoleId             || "");
  append("UserName",            data.UserName           || "");
  append("Email",               data.Email              || "");
  append("MobileNo",            data.MobileNo           || "");
  append("Password",            data.Password           || "");
  append("IsActive",            data.IsActive           ?? true);
  append("CreatedDate",         data.CreatedDate        || "");
  append("UpdatedDate",         data.UpdatedDate        || "");
  append("DealerId",            data.DealerId           ?? 0);
  append("UpdatedBy",           data.UpdatedBy          || "");

  // Business
  append("NameOfBussiness",     data.NameOfBussiness    || "");
  append("AddressFirm",         data.AddressFirm        || "");
  append("state",               data.state              || "");
  append("city",                data.city               || "");
  append("pincode",             data.pincode            || "");
  append("LandlineNo",          data.LandlineNo         || "");

  // PAN / GST  (URL strings — files already uploaded)
  append("PanNo",               data.PanNo              || "");
  append("PanNoDoc",            data.PanNoDoc           || "");
  append("GstNo",               data.GstNo              || "");
  append("GstCertificate",      data.GstCertificate     || "");

  // Company / Payment
  append("CompanyTypeId",       data.CompanyTypeId      || "");
  append("PaymentMode",         data.PaymentMode        || "");

  // Credit
  append("CreditDays",          data.CreditDays         || "");
  append("CreditLimit",         data.CreditLimit        || "");
  append("TurnoverPA",          data.TurnoverPA         || "");
  append("SecurityChequeNo",    data.SecurityChequeNo   || "");

  // Document URLs (already uploaded)
  append("AccountHolderImg",    data.AccountHolderImg   || "");
  append("ChequeImage",         data.ChequeImage        || "");
  append("ResAddressDoc1",      data.ResAddressDoc1     || "");
  append("ResAddressDoc2",      data.ResAddressDoc2     || "");
  append("CounterDoc",          data.CounterDoc         || "");

  // Owner
  append("DOB",                 data.DOB                || "");

  // Residential
  append("ResStateId",          data.ResStateId         || "");
  append("ResCityId",           data.ResCityId          || "");
  append("Respincode",          data.Respincode         || "");
  append("ResAddress",          data.ResAddress         || "");
  append("ResPhoneNo",          data.ResPhoneNo         || "");

  // Bank
  append("AccountNo",           data.AccountNo          || "");
  append("IfscCode",            data.IfscCode           || "");
  append("BankName",            data.BankName           || "");
  append("Branch",              data.Branch             || "");
  append("UpiAddress",          data.UpiAddress         || "");

  // Misc
  append("RegisterdBySalesId",  data.RegisterdBySalesId || "");
  append("AadharNo",            data.AadharNo           || "");
  append("AadharDoc1",          data.AadharDoc1         || "");
  append("AadharDoc2",          data.AadharDoc2         || "");
  append("DocumentNo",          data.DocumentNo         || "");
  append("DocumentType",        data.DocumentType       || "");

  // ── Get auth headers but REMOVE Content-Type ──────────────
  // authHeader() likely returns { Authorization: "Bearer ...", "Content-Type": "application/json" }
  // We must NOT set Content-Type manually — browser sets
  // "multipart/form-data; boundary=----..." automatically.
  const headers = authHeader();
  delete headers["Content-Type"];
  delete headers["content-type"];

  const requestOptions = {
    method: "POST",
    headers: headers,   // only Authorization remains
    body: formData,     // FormData, NOT JSON.stringify
  };

  console.log("dealer service requestOptions (FormData — inspect in Network tab):", requestOptions);

  const response = await fetch(
    `${process.env.REACT_APP_API_URL}UserReg/CreateDistributor`,
    requestOptions
  );
console.log("dealer service response:", response);
  return handleResponse(response);
}

// ============================================================
// FILE 5: services/dealer.service.js
// Add updateDistributor alongside existing createDistributor
// ============================================================
 
async function updateDistributor(data) {
  console.log("updateDistributor raw data:", data);
 
  const formData = new FormData();
 
  const append = (key, val) => {
    if (val !== undefined && val !== null) {
      formData.append(key, val);
    }
  };
 
  // ── Required ──────────────────────────────────────────────
  append("UserId",              data.UserId           || 0);
  append("DealerId",              data.DealerId           || 0);
  append("UpdatedBy",             data.UpdatedBy          || "");
 
  // ── UserMaster ────────────────────────────────────────────
  append("UserName",              data.UserName           || "");
  append("Email",                 data.Email              || "");
  append("MobileNo",              data.MobileNo           || "");
 
  // ── Business ──────────────────────────────────────────────
  append("NameOfBussiness",       data.NameOfBussiness    || "");
  append("AddressFirm",           data.AddressFirm        || "");
  append("state",                 data.state              || "");
  append("city",                  data.city               || "");
  append("pincode",               data.pincode            || "");
  append("LandlineNo",            data.LandlineNo         || "");
 
  // ── PAN / GST ─────────────────────────────────────────────
  append("PanNo",                 data.PanNo              || "");
  append("PanNoDoc",              data.PanNoDoc           || "");
  append("GstNo",                 data.GstNo              || "");
  append("GstCertificate",        data.GstCertificate     || "");
 
  // ── Company / Payment ─────────────────────────────────────
  append("CompanyTypeId",         data.CompanyTypeId      || "");
  append("PaymentMode",           data.PaymentMode        || "");
 
  // ── Credit ────────────────────────────────────────────────
  append("CreditDays",            data.CreditDays         || "");
  append("CreditLimit",           data.CreditLimit        || "");
  append("TurnoverPA",            data.TurnoverPA         || "");
  append("SecurityChequeNo",      data.SecurityChequeNo   || "");
 
  // ── Documents (send existing URL if no new file chosen) ───
  append("AccountHolderImg",      data.AccountHolderImg   || "");
  append("ChequeImage",           data.ChequeImage        || "");
  append("ResAddressDoc1",        data.ResAddressDoc1     || "");
  append("ResAddressDoc2",        data.ResAddressDoc2     || "");
  append("CounterDoc",            data.CounterDoc         || "");
 
  // ── Owner ─────────────────────────────────────────────────
  append("DOB",                   data.DOB                || "");
 
  // ── Residential ───────────────────────────────────────────
  append("ResStateId",            data.ResStateId         || "");
  append("ResCityId",             data.ResCityId          || "");
  append("Respincode",            data.Respincode         || "");
  append("ResAddress",            data.ResAddress         || "");
  append("ResPhoneNo",            data.ResPhoneNo         || "");
 
  // ── Bank ──────────────────────────────────────────────────
  append("AccountNo",             data.AccountNo          || "");
  append("IfscCode",              data.IfscCode           || "");
  append("BankName",              data.BankName           || "");
  append("Branch",                data.Branch             || "");
  append("UpiAddress",            data.UpiAddress         || "");
 
  // ── Misc ──────────────────────────────────────────────────
  append("RegisterdBySalesId",    data.RegisterdBySalesId || "");
  append("UserRegCode",           data.UserRegCode        || "");
 
  // Remove Content-Type so browser sets multipart+boundary
  const headers = authHeader();
  delete headers["Content-Type"];
  delete headers["content-type"];
 
  const requestOptions = {
    method: "POST",
    headers: headers,
    body: formData,
  };
 
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}UserReg/UpdateDistributor`,
    requestOptions
  );
  return handleResponse(response);
}

async function updateDealer(data) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  };
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}UserDMaster/UpdateDealer`,
    requestOptions
  );
  return handleResponse(response);
}

async function GetDistributorByUserId(userId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const response = await fetch(
    `${process.env.REACT_APP_API_URL}UserDMaster/FrimByUserId?userId=${userId}`,
    requestOptions
  );

  return handleResponse(response);
}

async function updateContractor(data) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  };
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}UserDMaster/UpdateDealerUserApprovalContractor`,
    requestOptions
  );
  return handleResponse(response);
}

async function fetchStateDLL(countryId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const response = await fetch(
    `${process.env.REACT_APP_API_URL}UserDMaster/GetStateDLL/${countryId}`,
    requestOptions
  );
  return handleResponse(response);
}

async function fetchDStateDLL(countryId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const response = await fetch(
    `${process.env.REACT_APP_API_URL}UserDMaster/GetStateDLL/${countryId}`,
    requestOptions
  );
  return handleResponse(response);
}

async function fetchCityDLL(userId) {

  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const response = await fetch(
    `${process.env.REACT_APP_API_URL}UserDMaster/GetCityDLL/${userId}`,
    requestOptions
  );
  return handleResponse(response);
}

async function fetchDCityDLL(userId) {

  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const response = await fetch(
    `${process.env.REACT_APP_API_URL}UserDMaster/GetCityDLL/${userId}`,
    requestOptions
  );
  return handleResponse(response);
}

async function fetchDCityDLL2() {

  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const response = await fetch(
    `${process.env.REACT_APP_API_URL}UserDMaster/GetCityDLL2`,
    requestOptions
  );
  return handleResponse(response);
}
async function fetchDistrictDLL(userId) {

  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const response = await fetch(
    `${process.env.REACT_APP_API_URL}UserDMaster/GetDistrictDDL/${userId}`,
    requestOptions
  );
  return handleResponse(response);
}

async function fetchFirmDLL() { 

  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const response = await fetch(
 
    `${process.env.REACT_APP_API_URL}UserReg/GetCompanyDDl`,
    requestOptions
  );
  return handleResponse(response);
}

async function GETPAYMENTDDL() {
  
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  const response = await fetch(
 
    `${process.env.REACT_APP_API_URL}UserReg/GetPyamnetTypeDDl`,
    requestOptions
  );
  return handleResponse(response);
}
 
async function GETDOCUMENTTYPEDDL() {
  
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const response = await fetch(
 
    `${process.env.REACT_APP_API_URL}List/GetListDataForDDL?id=1`,
    requestOptions
  );
  return handleResponse(response);
}


async function GetSalesPersonDDL() {
  
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const response = await fetch(
 
    `${process.env.REACT_APP_API_URL}UserdMaster/GetAllSalesPersonDDL`,
    requestOptions
  );
  return handleResponse(response);
}
// async function fetchRoleDLL(userId) {
//   const requestOptions = {
//       method: 'GET',
//       headers: authHeader()
//   };

//   const response = await fetch(`${process.env.REACT_APP_API_URL}RoleMaster/GetRoleDLL/${2}`, requestOptions);
//   return handleResponse(response);
// }

async function fetchTransportationModeDDL() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const response = await fetch(
    `${process.env.REACT_APP_API_URL}UserDMaster/GetTransportationModeDLL`,
    requestOptions
  );
  return handleResponse(response);
}


async function fetchDealerData(data) {
  
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  };

  const response = await fetch(
    `${process.env.REACT_APP_API_URL}UserDMaster/GetDealers`,
    requestOptions
  );
  return handleResponse(response);
}

async function fetchDealerDatatoApprove(data) {
  
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  };

  const response = await fetch(
    `${process.env.REACT_APP_API_URL}UserDMaster/GetDealerstoApprove`,
    requestOptions
  );
  return handleResponse(response);
}

async function fetchDealerDataforExport(data) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  };

  const response = await fetch(
    `${process.env.REACT_APP_API_URL}UserDMaster/GetDealers`,
    requestOptions
  );
  return handleResponse(response);
}

async function inActiveRow(UserId, isActive) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}UserDMaster/InActiveRow/${UserId}/${isActive}`,
    requestOptions
  );
  return handleResponse(response);
}

export async function updatePaymentStatus(userId, isPayment) {
  
  const requestOptions = {
    method: "GET", // ❗️ ideally should be POST or PUT for updates
    headers: authHeader(),
  };

  const response = await fetch(
    `${process.env.REACT_APP_API_URL}UserDMaster/UpdatePaymentStatus/${userId}`,
    requestOptions
  );

  return handleResponse(response);
}

